<template>
<div class="chapter">
<div class="inner_page">
<p class="SP"> </p>
<p class="EPI-V">Now as you walk about the streets, sirs</p>
<p class="EPI-V">You Pickwick’s face are sure to meet, sirs</p>
<p class="EPI-V">You call a cab, and this, sirs, poz is</p>
<p class="EPI-V">Upon the sides the name of Boz is</p>
<p class="EPI-V">You’re for the play a precious fellow</p>
<p class="EPI-V">And so you go and see Sam Weller</p>
<p class="EPI-V">These things have come to such an odd pass</p>
<p class="EPI-V">My wife has christened the baby Snodgrass.</p>
<p class="EPIS">Song, ‘The Pickwick Age’</p>
<p class="EPI-A">No prose work of fiction of this or any other age has been read and read again by so many people, none has raised so much healthy mirth, none has called forth so large a bibliography of history, commentary and illustration and none is so freely quoted, consciously or unconsciously in the literature and conversation of today.</p>
<p class="EPIS">Hammond Hall, <span class="ePub-I">Mr Pickwick’s Kent </span>(<span class="non-aligning-figs-regular-1">1899</span>)</p>
<p class="EPI-A">Whoever shall truly relate the history of the people of Great Britain in the nineteenth century will not pass by in silence the publication of <span class="ePub-I">Pickwick</span>.</p>
<p class="EPIS">James Parton (<span class="non-aligning-figs-regular-1">1822</span>–<span class="non-aligning-figs-regular-1">91</span>)</p>
<p class="EPI-F"><span class="ePub-I">Pickwick</span> is a reality to all of us.</p>
<p class="EPIS"><span class="ePub-I">British Journal of Photography</span> (<span class="non-aligning-figs-regular-1">1903</span>)</p>
<p class="EPI-A">There is perhaps in every thing of consequence a secret history which it would be amusing to know, could we have it authentically communicated.</p>
<p class="EPIS">James Boswell</p>
<p class="EPI-F">Behind every beautiful thing there’s been some kind of pain.</p>
<p class="EPIS">Bob Dylan, ‘Not Dark Yet’</p>
<p class="EPI-F">[<span class="ePub-I">The Pickwick Papers</span>] reveals itself as being at some deep structural level about the act of its own coming into existence.</p>
<p class="EPIS">Professor Steven Marcus</p>
<p class="EPI-A">I am inclined to believe the figures of Pickwick and his clubmates were in existence before Dickens had any connection whatever with Seymour’s work.</p>
<p class="EPIS">R.W. Buss (<span class="non-aligning-figs-regular-1">1804</span>–<span class="non-aligning-figs-regular-1">75</span>)</p>
<p class="EPI-F">Dickens was a very clever man but he was not an honest man.</p>
<p class="EPIS">George Bentley (<span class="non-aligning-figs-regular-1">1828</span>–<span class="non-aligning-figs-regular-1">95</span>)</p>
<p class="EPI-A">A man hath no better thing under the sun, than to eat, and to drink, and to be merry.</p>
<p class="EPIS">Ecclesiastes</p>
<p class="EPI-F">Let me have men about me that are fat.</p>
<p class="EPIS">William Shakespeare, <span class="ePub-I">Julius Caesar</span></p>
<p class="EPI-F">‘The Show Must Go On’</p>
<p class="EPIS">Song by Queen</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?a70a7d18